import type { Point } from '../../types/diagram.tsx';

/** Path drawing instruction to jump to a Point (absolute value) without drawing
 *
 * Used along with {@link line} and {@link combinePath} */
export const move = ({ x, y }: Point) => `M${x},${y}`;

/** Path drawing instruction to draw to a Point from current point in a path to
 * the Point (absolute value) provided.
 *
 * * Used along with {@link move} and {@link combinePath}.
 * * Use  {@link lineUp}, {@link lineDown} etc for relative movement. */
export const line = ({ x, y }: Point) => `L${x},${y}`;

export const lineUp = (amount: number) => `l0,${-amount}`;
export const lineDown = (amount: number) => `l0,${amount}`;
export const lineLeft = (amount: number) => `l${-amount},0`;
export const lineRight = (amount: number) => `l${amount},0`;

/** Joins path instructions.
 *
 * Used along with {@link move} and {@link line}
 */
export const combinePath = (...components: string[]) => components.join('');
